import { render, staticRenderFns } from "./page-debug.vue?vue&type=template&id=e81575c0&scoped=true&"
import script from "./page-debug.vue?vue&type=script&lang=js&"
export * from "./page-debug.vue?vue&type=script&lang=js&"
import style0 from "./page-debug.vue?vue&type=style&index=0&id=e81575c0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e81575c0",
  null
  
)

export default component.exports